export default {
  // API_ENDPOINT: 'http://localhost:8000/api',
  API_ENDPOINT: 'https://motive-server.herokuapp.com/api',
  TOKEN_KEY: 'motive-auth-token',
}